import React, { createContext, useContext, useState } from "react";
import { GrSnackbar, GrSnackbarProps } from "@jnpmedi/grebob";

type SnackbarProps = Pick<GrSnackbarProps, "type" | "severity" | "autoHideDuration" | "message" | "action" | "style">;

interface SnackbarContextType {
  notify: (snackbar: SnackbarProps) => void;
}

const SnackbarContext = createContext<SnackbarContextType | undefined>(undefined);

export const useSnackbarContext = () => {
  const context = useContext<SnackbarContextType | undefined>(SnackbarContext);

  if (!context) throw new Error("useSnackbarContext must be used within a SnackbarProvider");

  return context;
};

interface SnackbarProviderProps {
  children: React.ReactNode;
}

export const SnackbarProvider = ({ children }: SnackbarProviderProps) => {
  const [open, setOpen] = useState<boolean>(false);
  const [snackbar, setSnackbar] = useState<SnackbarProps | undefined>();
  const notify = (snackbarProps: SnackbarProps) => {
    setSnackbar(snackbarProps);
    setOpen(true);
  };

  const closeSnackbar = () => {
    setOpen(false);
  };

  return (
    <SnackbarContext.Provider value={{ notify }}>
      <GrSnackbar
        open={open}
        onClose={closeSnackbar}
        autoHideDuration={snackbar?.autoHideDuration ?? 2000}
        {...snackbar}
        style={{
          top: "4.875rem",
          right: "1rem",
          width: "340px",
          ...snackbar?.style,
        }}
      />
      {children}
    </SnackbarContext.Provider>
  );
};
